module.exports = __webpack_public_path__ + "static/img/Zac-Lomax.1fd1fb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Zac-Lomax.jpg
// module id = SXu1
// module chunks = 0